import "babel-polyfill"
import "normalize.css"

// Change the import names to avoid conflict with export names
import { wrapRootElement as rootWrapper, browserWrapPageElement as pageWrapper } from "@src/wrappers"

// Re-export with the correct names
export const wrapRootElement = rootWrapper
export const wrapPageElement = pageWrapper

const exploreRoutes = [
    '/identity-and-stats',
    '/people-and-stories',
    '/allyship',
]

export const shouldUpdateScroll = ({
    routerProps: { location },
    prevRouterProps,
}) => {
    const prevLocation = prevRouterProps?.location
    if (exploreRoutes.includes(location.pathname) && exploreRoutes.includes(prevLocation?.pathname)) {
        return false
    }
    if (location.pathname !== prevLocation?.pathname) {
        return [0, 0]
    }
    return false
}